import React from "react";
import { Reveal } from "@/components/Reveal";
import { Eyebrow } from "@/components/SectionDivider";
import { Check } from "lucide-react";

const CARDS = [
  {
    title: "Citibank Virtual Account",
    place: "USA",
    items: [
      "USD bank account in the USA",
      "Held in the client's own name",
      "Fund from your Indian bank via LRS",
      "Withdraw to any bank account globally",
      "Full SWIFT international wire access",
    ],
  },
  {
    title: "Interactive Brokers",
    place: "USA",
    items: [
      "Global brokerage in the client's name",
      "US stocks, ETFs, bonds and more",
      "Regulated by SEC and FINRA",
      "Actively managed by NAG ANALYTIX",
      "Full real-time portfolio visibility",
    ],
  },
];

const WhereAndHow = () => {
  return (
    <section
      id="where-and-how"
      data-testid="where-section"
      className="relative bg-[#111111] py-24 md:py-32"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <Reveal>
          <Eyebrow testId="where-eyebrow">Where &amp; How</Eyebrow>
          <h2
            data-testid="where-heading"
            className="font-serif-display text-[#C9960C] text-4xl sm:text-5xl lg:text-6xl tracking-tight leading-[1.05]"
          >
            Accounts Held in Your Name
          </h2>
        </Reveal>

        <div className="mt-16 grid grid-cols-1 md:grid-cols-2 gap-8">
          {CARDS.map((c, idx) => (
            <Reveal key={c.title} delay={idx * 0.15}>
              <article
                data-testid={`where-card-${idx + 1}`}
                className="bg-[#1C1C1C] border border-[#C9960C]/40 border-t-2 border-t-[#C9960C] p-10 md:p-12 h-full flex flex-col"
              >
                <div className="flex items-baseline justify-between mb-6">
                  <h3 className="font-serif-display text-[#F5D485] text-3xl sm:text-4xl tracking-tight">
                    {c.title}
                  </h3>
                  <span className="text-[11px] tracking-[0.32em] uppercase text-[#C9960C] border border-[#C9960C]/40 px-2.5 py-1">
                    {c.place}
                  </span>
                </div>
                <div className="h-px w-full bg-[#C9960C]/25 my-6" />
                <ul className="space-y-4">
                  {c.items.map((it) => (
                    <li key={it} className="flex items-start gap-3 text-[#F8F6F0]/85 leading-relaxed">
                      <Check size={16} className="text-[#C9960C] shrink-0 mt-1" />
                      <span>{it}</span>
                    </li>
                  ))}
                </ul>
              </article>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};

export default WhereAndHow;
